document.addEventListener("DOMContentLoaded", () => {
  const checkboxes = document.querySelectorAll(".input_checkbox"),
  addOnQtyElement = document.getElementById("addOnQty"),
  addOnPriceElement = document.getElementById("addOnPrice"),
  sugestedTotPriceElement = document.getElementById("sugestedTotPriceDesktop"),
  fbtGrid = document.querySelector(".fbt-grid"),
  submitButton = document.querySelector('#ATCFBT'),
  currencySymbol = document.querySelector("header")?.getAttribute("data-currency-symbol") || "$",
  firstProductElement = document.querySelector(".first-product"),
  firstProductPrice = firstProductElement ? parseFloat(firstProductElement.getAttribute("data-price-fbt")) || 0 : 0;

  const getProductDataFromElement = (checkbox) => {
    const parentElement = checkbox.closest(".addons_product");
    return parentElement ? {
      productId: parentElement.getAttribute("data-fbt-id"),
      priceFbt: parseFloat(parentElement.getAttribute("data-price-fbt")) || 0
    } : { productId: null, priceFbt: 0 };
  }

  const getCheckedProductIds = () => {
  const productVarIds = [firstProductElement ? Number(firstProductElement.getAttribute("data-fbt-id")) : null].filter(Boolean);
  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      const { productId } = getProductDataFromElement(checkbox);
      productVarIds.push(Number(productId)); // Ensure all IDs are numbers
    }
  });
  return productVarIds;
};


  const updateCheckedProducts = () => {
    let totalCheckedQty = 0, totalPrice = 0;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const { priceFbt } = getProductDataFromElement(checkbox);
        totalCheckedQty++;
        totalPrice += priceFbt;
      }
    });

    fbtGrid?.classList.toggle("no-checked-product", totalCheckedQty === 0);
    addOnQtyElement.textContent = totalCheckedQty;
    addOnQtyElement.parentElement.style.display = totalCheckedQty ? "block" : "none";
    if (currencySymbol === '€') {
    addOnPriceElement.textContent = `${currencySymbol}${(totalPrice / 100).toFixed(2)}`;
    sugestedTotPriceElement.textContent = `${currencySymbol}${((totalPrice + firstProductPrice) / 100).toFixed(2)}`;
    }
    else{
    let formattedTotalPrice = (totalPrice / 100).toFixed(2);
    let formattedSuggestedPrice = ((totalPrice + firstProductPrice) / 100).toFixed(2);

  
    if (currencySymbol === 'kr.') {
        formattedTotal__Price = formattedTotalPrice.replace('.', ',');
        formattedSuggested__Price = formattedSuggestedPrice.replace('.', ',');
        addOnPriceElement.textContent = `${formattedTotal__Price} ${currencySymbol}`;
        sugestedTotPriceElement.textContent = `${formattedSuggested__Price} ${currencySymbol}`;
    }
      else{
         addOnPriceElement.textContent = `${formattedTotalPrice}${currencySymbol}`;
        sugestedTotPriceElement.textContent = `${formattedSuggestedPrice}${currencySymbol}`;
      }

   
    }
    const computedPrice = (totalPrice + firstProductPrice) / 100;
      

    const otherBenefitsElement = document.querySelector('.otherBenefits');

   // Check the condition and toggle the hidden class
   if (computedPrice < 35) {
     otherBenefitsElement.classList.add('hidden');
   } else {
     otherBenefitsElement.classList.remove('hidden');
   }
  }

  updateCheckedProducts();

  fbtGrid?.addEventListener("change", (event) => {
    if (event.target?.classList.contains("input_checkbox")) updateCheckedProducts();
  });

  submitButton.addEventListener("click", () => {
    const productVarIds = getCheckedProductIds();
    console.log('Product IDs to add to cart:', productVarIds);
    if (productVarIds.length) ajaxCallUpdateCart(productVarIds);
  });

  // FBT posts straight to /cart/add.js, bypassing cart.js's own call sites, so the free-gift and
  // auto-product handlers never ran: an FBT add that crossed a threshold opened the drawer without
  // the earned freebie. Run them here, sequentially and re-reading the cart between each so every
  // handler sees the previous one's add/remove (same order as cart.js's cartUpdate path), and do it
  // BEFORE the drawer HTML is loaded below — otherwise the drawer renders the pre-gift cart.
  // Capped, and it never rejects: a slow or broken freebie step must not keep the drawer shut.
  const syncFreebiesAfterAdd = async () => {
    const readCart = async (fallback) => {
      try {
        return await fetch(window.Shopify.routes.root + 'cart.js', {
          headers: { Accept: 'application/json' }
        }).then((r) => r.json());
      } catch (e) {
        return fallback;
      }
    };

    const run = (async () => {
      try {
        const cart = await readCart(null);
        if (!cart) return;
        await window.handleRotatingGift?.(cart);
        const cart2 = await readCart(cart);
        await window.handleGiftProduct?.(cart2);
        const cart3 = await readCart(cart2);
        await window.handleAutoProduct?.(cart3);
      } catch (e) {
        console.error('FBT freebie sync failed:', e);
      }
    })();

    await Promise.race([run, new Promise((resolve) => setTimeout(resolve, 3000))]);
  };

  const ajaxCallUpdateCart = (productVarIds) => {
  const formData = {
    items: productVarIds.map(id => ({ id, quantity: 1 }))
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(() => syncFreebiesAfterAdd())
  .then(() => {
    // Load the *children* of the fetched element ("> *"), not the element itself.
    // Without "> *" jQuery injects the whole matched <a id="cart-icon-bubble">
    // inside the live one, leaving a duplicate icon (extra space) in the header.
    $('.header #cart-icon-bubble').load(location.href + " #cart-icon-bubble > *");
    $('.header-dropdown_menu #cart-icon-bubble').load(location.href + " #cart-icon-bubble > *");

    // Load CartDrawer and THEN run drawer-related logic
    $('#CartDrawer').load(location.href + " #CartDrawer > *", function () {
      const drawer = document.querySelector(".drawer");
      const cartDrawer = document.querySelector("cart-drawer");
      const overlay = document.getElementById("CartDrawer-Overlay");

      if (drawer) {
        drawer.classList.remove("is-empty");
        drawer.classList.add("animate", "active");
        // Lock body scroll like the normal drawer open() does — this manual open
        // bypasses cart-drawer.js, so add the class here too.
        document.body.classList.add("overflow-m-hidden");
    
        let currentUrl = new URL(window.location.href);
        console.log('Current URL:', currentUrl.href);
        currentUrl.searchParams.set('cartOpen', 'true');
        console.log('Updated URL:', currentUrl.href);
        window.history.replaceState({}, '', currentUrl);
      }

      if (overlay && cartDrawer) {
        overlay.addEventListener("click", () => {
          cartDrawer.classList.remove("active");
          document.body.classList.remove("overflow-m-hidden");
        });
      }

      // The drawer markup we just injected renders #cart-drawer-gift-fab-wrap and every
      // .cd-gift-strip with `hidden` — only cart.js reveals them. cart.js's own refresh paths
      // call this after re-rendering (see refreshCartDrawer / the cartUpdate handler); this
      // manual .load() bypasses them, so without it the gift FAB stayed hidden after an FBT
      // add even once the threshold was met.
      window.updateCartDrawerGiftStrips?.();
    });
  })
  .catch(console.error);
};

});